module.exports = {
  apiBaseUrl:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://castlerewrite.castlelearning.com/api'
      : process.env.REACT_APP_ENV === 'testing'
        ? 'https://qa-castlerewrite.castlelearning.com/api'
        : process.env.REACT_APP_ENV === 'rc'  
          ? 'https://rc-castlerewrite.castlelearning.com/api'
          : 'http://localhost:5001',

  nycRedirectUrl:
    process.env.REACT_APP_ENV === 'production'
      ? 'https://sso.castlelearning.com/signon/cl'
      : process.env.REACT_APP_ENV === 'rc'
        ? 'https://sso.castlelearning.com/signon/rc'
        : 'https://sso.castlelearning.com/signon/qa',

  castleSupportCode: 'castlesupport',

  googleAnalyticsKey:
    process.env.REACT_APP_ENV === 'production'
      ? 'G-NRV86QHPS2'
      : process.env.REACT_APP_ENV === 'testing'
        ? 'G-G6RBP0T548'
        : process.env.REACT_APP_ENV === 'rc'  
          ? ''
          : '',
};
